var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2537 12.9781L13.1707 12.0879C12.224 13.2752 10.6146 14.0664 8.72082 14.0664C6.82746 14.0664 5.1232 13.2749 4.27094 12.0879L2.18797 12.9781C1.24129 13.3739 0.672976 14.4622 0.862498 15.4515L2.47192 25.0482C2.66113 26.0374 3.60812 26.829 4.55489 26.829H12.8863C13.833 26.829 14.7797 26.0375 14.9693 25.0482L16.5787 15.4515C16.7686 14.4619 16.1055 13.2748 15.2536 12.9781H15.2537Z",
    fill: "#27C69E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6958 5.0794C12.6958 5.0794 12.5066 4.48589 12.2223 3.49626C11.6543 1.91313 10.1393 0.825195 8.52989 0.825195C7.10966 0.924227 5.97379 1.71543 5.40548 3.00185C5.40548 3.00185 5.02673 3.59535 4.74276 5.07948C4.45878 6.36555 4.26924 8.14638 4.1748 9.33368C4.1748 9.72947 4.45878 10.0262 4.83752 10.0262H12.7902C13.1689 10.0262 13.4529 9.72946 13.4529 9.33368C13.2637 8.04762 13.0742 6.26679 12.6957 5.07948L12.6958 5.0794Z",
    fill: "#27C69E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female_icon.b112299a265d1d2fcb135afb55f165c5.svg";
export { ForwardRef as ReactComponent };